import { render, staticRenderFns } from "./PersonalPropertyCategorySelect.vue?vue&type=template&id=3520aa3e"
import script from "./PersonalPropertyCategorySelect.vue?vue&type=script&lang=ts"
export * from "./PersonalPropertyCategorySelect.vue?vue&type=script&lang=ts"
import style0 from "./PersonalPropertyCategorySelect.vue?vue&type=style&index=0&id=3520aa3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports